export enum Theme {
  HIPSTER = 'HIPSTER',
  BLOSSOM = 'BLOSSOM',
  CONCIERGE = 'CONCIERGE',
}
